import React, { useState } from 'react';
import { CarTypeCarousel } from '../components/CarTypeCarousel';
import { CarListingGrid } from '../components/CarListingGrid';
interface CatalogPageProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export function CatalogPage({
  searchQuery,
  setSearchQuery
}: CatalogPageProps) {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  return <>
      <div className="max-w-[1600px] mx-auto flex" data-id="element-302">
        <main className="flex-1 p-4 md:p-6 lg:p-8 min-w-0" data-id="element-303">
          <h1 className="text-2xl font-bold text-[#4A90E2] mb-6" data-id="element-304">Catálogo</h1>

          <CarTypeCarousel selectedType={selectedType} onSelectType={setSelectedType} data-id="element-305" />
          <CarListingGrid searchQuery={searchQuery} selectedType={selectedType} data-id="element-306" />
        </main>
      </div>
    </>;
}